"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isContentDTO = exports.isWidgetDTO = exports.isQuestionDTO = void 0;
function isQuestionDTO(item) {
    return item.type === "QUESTION";
}
exports.isQuestionDTO = isQuestionDTO;
function isWidgetDTO(item) {
    return item.type === "WIDGET";
}
exports.isWidgetDTO = isWidgetDTO;
function isContentDTO(item) {
    return item.type === "CONTENT";
}
exports.isContentDTO = isContentDTO;
//# sourceMappingURL=formSectionVm.js.map